import { createRouter, createWebHistory } from '@ionic/vue-router';


// import TabsPage from '../views/TabsPage.vue'

const routes = [
  {
    path: '/',
    component: () => import('../App.vue'),
  },
  // {
  //   path: '/',
  //   component: () => import('@/app.vue')
  // },
  // {
  //   path: '/subscriptionsuccess',
  //   component: () => import('@/components/SubscriptionSuccess.vue')
  // },
  // {
  //   path: '/tabs/',
  //   component: TabsPage,
  //   children: [
  //     {
  //       path: '',
  //       redirect: '/tabs/tab1'
  //     },
  //     {
  //       path: 'tab1',
  //       component: () => import('@/views/AvatarHomePage.vue')
  //     },
  //     {
  //       path: 'tab2',
  //       component: () => import('@/views/ChatHistory.vue')
  //     },
  //     {
  //       path: 'tab3',
  //       component: () => import('@/views/ChartView.vue')
  //     },
  //     {
  //       path: 'tab4',
  //       component: () => import('@/views/ChartView.vue')
  //     }
  //   ]
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
